import { render, staticRenderFns } from "./ShipmentsIndex.vue?vue&type=template&id=4d9bf69a"
import script from "./ShipmentsIndex.vue?vue&type=script&lang=js"
export * from "./ShipmentsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports